/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import { globalHistory } from '@reach/router';

export const onServiceWorkerUpdateReady = () => {
  window.location.reload();
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.href.indexOf('agenda/#') === -1
    && location.href.indexOf('agenda#') === -1
    && location.href.indexOf('speakers#') === -1
    && location.href.indexOf('speakers/#') === -1) {
    window.scrollTo(0, 0);
  }

  return false;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Track pageview with google analytics
  const pageTitle = location.pathname.replace('/', '');
  // eslint-disable-next-line no-undef
  if (typeof dataLayer !== 'undefined') {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'VirtualPageview',
      virtualPageURL: location.pathname + location.search + location.hash,
      virtualPageTitle: pageTitle === '' ? 'Money20/20 Asia' : pageTitle,
    });
  }
};

export const onInitialClientRender = () => {
  /**
   * This is a workaround for a bug in Gatsby
   *
   * See https://github.com/gatsbyjs/gatsby/issues/8357 for more details
   * https://toprightgroup.atlassian.net/browse/BRO-502
   */
  globalHistory._onTransitionComplete();
};

